import { map, toNumber } from 'lodash';

import {
  CompanyRequestModel,
  FullBOUserResponseModel,
  ProfileTypeEnum,
} from 'api/backofficeApiClient';

export interface CompanyProfileFormValues {
  ownerInfo: {
    firstName: string;
    lastName: string;
    email: string;
  };
  bestContact: {
    sameAsOwner: boolean;
    firstName?: string;
    lastName?: string;
  };
  emailForCommunications: {
    sameAsOwner: boolean;
    email?: string;
  };
  businessName: string;
  businessPhone: string;
  country?: number;
  state?: number;
  internationalStateName?: string;
  city: string;
  internationalCityName?: string;
  address: string | null;
  zip: string;
  businessEmail: string;
  industry: string[];
  assignmentLocations?: number[] | null;
  assignment?: boolean;
  termsAndConditions?: boolean;
  isRegisteredOnMarketPlace?: boolean;
  website?: string;
  clientSuccessPartnerUserId?: string;
  bdSalesContactUserId?: string;
  billingSpecialistUserId?: string;
  recipientEmail1?: string;
  recipientEmail2?: string;
  recipientEmail3?: string;
}

export const mapCompanyProfileToRequest = (
  values: CompanyProfileFormValues,
  profileInfo?: FullBOUserResponseModel,
): CompanyRequestModel => {
  const {
    ownerInfo,
    bestContact,
    emailForCommunications,
    businessName,
    businessPhone,
    state,
    city,
    address,
    zip,
    website,
    industry,
    assignmentLocations,
    assignment,
    businessEmail,
    country,
    internationalCityName,
    internationalStateName,
    clientSuccessPartnerUserId,
    bdSalesContactUserId,
    billingSpecialistUserId,
    recipientEmail1,
    recipientEmail2,
    recipientEmail3,
  } = values;

  const isCorporateTAProfileType =
    profileInfo?.profileType === ProfileTypeEnum.Corporate;

  return {
    website: website || undefined,
    ownerInfo: {
      firstName: ownerInfo.firstName.trim(),
      lastName: ownerInfo.lastName.trim(),
      email: ownerInfo.email.trim(),
    },

    bestContact: {
      firstName: bestContact.sameAsOwner
        ? ownerInfo.firstName.trim()
        : bestContact.firstName?.trim(),
      lastName: bestContact.sameAsOwner
        ? ownerInfo.lastName.trim()
        : bestContact.lastName?.trim(),
      email: emailForCommunications.sameAsOwner
        ? ownerInfo.email.trim()
        : emailForCommunications.email?.trim(),
    },

    businessInfo: {
      name: businessName.trim(),
      phoneNumber: businessPhone.trim(),
      location: {
        countryId: toNumber(country),
        stateId: state || undefined,
        city: city.trim(),
        address: address?.trim(),
        zipCode: zip?.trim() || undefined,
        internationalStateName: internationalStateName || undefined,
        internationalCityName: internationalCityName?.trim() || undefined,
      },
      businessEmail: isCorporateTAProfileType
        ? businessEmail?.trim()
        : undefined,
      industry,

      // for edit we need pass those two fields too, because it is required
      assignmentLocations:
        (!!profileInfo?.businessInfo
          ? (map(
              profileInfo?.businessInfo?.assignmentLocations,
              'id',
            ) as number[])
          : assignmentLocations) || undefined,
      assignment: !!profileInfo?.businessInfo
        ? profileInfo?.businessInfo?.assignment
        : assignment,
    },
    companyId: profileInfo?.companyId || undefined,
    mbpContactsInfo:
      clientSuccessPartnerUserId ||
      bdSalesContactUserId ||
      billingSpecialistUserId
        ? {
            clientSuccessPartnerUserId: clientSuccessPartnerUserId || undefined,
            bdSalesContactUserId: bdSalesContactUserId || undefined,
            billingSpecialistUserId: billingSpecialistUserId || undefined,
          }
        : undefined,
    activityReportRecipients:
      recipientEmail1 || recipientEmail2 || recipientEmail3
        ? {
            recipientEmail1: recipientEmail1?.trim() || undefined,
            recipientEmail2: recipientEmail2?.trim() || undefined,
            recipientEmail3: recipientEmail3?.trim() || undefined,
          }
        : undefined,
  };
};
